import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { OrgInvoiceRecords } from "./org-invoice-records";

@TypeManagerDecorator("s25-ng-org-invoice-status-cell")
@Component({
    selector: "s25-ng-org-invoice-status-cell",
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ` <span class="c-state-badge" [class]="badgeClass()">{{ label() }}</span> `,
})
export class OrgInvoiceStatusCellComponent {
    readonly status = input.required<OrgInvoiceRecords.Status>();

    protected readonly label = computed(
        () => ({ paid: "Paid", outstanding: "Outstanding", overdue: "Overdue" })[this.status()],
    );
    protected readonly badgeClass = computed(
        () =>
            ({
                paid: "c-state-badge--green",
                outstanding: "c-state-badge--yellow",
                overdue: "c-state-badge--red",
            })[this.status()],
    );
}
